module.exports = __webpack_public_path__ + "img/9791187038696.f0c4688c.jpg";